import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LeadResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                id: 'b7f0c2de-5a3e-4c1a-9a4e-3f6f1f0d2a11',
                fantasy_name: "Michael's Bakery",
                phone: '1122334455',
                email: 'michael@dundermifflin.com',
                origin_channel: 'WhatsApp',
                how_they_knew_us: 'Meta',
                referral_observation: '',
                commerce_type: 'Panadería',
                commerce_type_specification: '',
                interest_products: ['Panes'],
                commercial_channel: 'Horeca',
                business_name: 'Dunder Mifflin',
                taxpayer_identification_number: '30712345678',
                belongs_to_a_disabled_customer: false,
                is_possible_duplicate: false,
                franchise_brand_name: "McDonald's",
                creation_datetime: '2026-10-17T14:30:00-03:00',
                stage: 'NEW',
                has_responsible: true,
                responsible: 'closer@saporedipane.com',
                lead_delivery_sites: [{
                    id: 'c1a5d8f4-7e20-4b39-8d61-0a9e4c7b5f32',
                    name: 'Main store',
                    jurisdiction: 'Capital Federal',
                    out_of_zone: false,
                    location: {
                        address: '1725 Slough Ave',
                        city: 'CABA',
                        postal_code: '1425',
                        latitude: '-34.6037',
                        longitude: '-58.3816',
                    },
                }],
            },
            errors: [],
        };
    }

    fantasyName() {
        return this.content().fantasy_name;
    }

    stage() {
        return this.content().stage;
    }

    commercialChannel() {
        return this.content().commercial_channel;
    }

    isOfACurrentCustomer() {
        return this.stage() === 'CURRENT_CUSTOMER';
    }

    outOfZoneLeadDeliverySiteNames() {
        return this.content().lead_delivery_sites
            .filter((leadDeliverySite) => leadDeliverySite.out_of_zone)
            .map((leadDeliverySite) => leadDeliverySite.name);
    }
}
